<template>
  <div class="backgroundGestionAmbiental" id="background3">
    <div class="transbox" id="transbox3">
      <h1 class="pulse">Gestión Ambiental</h1>
      <br>
      <ul>
        <li>Gestión de residuos industriales.</li>
        <li>Amianto (uralita).</li>
        <li>Lodos de depuradora.</li>
        <li>Envases plásticos.</li>
        <li>Envases metálicos.</li>
        <li>Absorbentes.</li>
        <li>Hidrocarburos.</li>
        <li>Fosa séptica.</li>
        <li>Tierras contaminadas.</li>
        <li>Vidrio, Lunas.</li>
        <li>Madera.</li>
        <li>Filtros de Aceite.</li>
        <li>Filtros de aire.</li>
        <li>Anticongelante.</li>
        <li>Baterías.</li>
        <li>Aceites.</li>
        <li>Aerosoles.</li>
        <li>Chatarra, Metales.</li>
        <li>Disolventes.</li>
        <li>Pinturas.</li>
        <li>Residuos sanitarios.</li>
        <li>Residuos electrónicos.</li>
        <li>Más de 700 códigos LER de residuos…….</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GestionAmbiental',
  props: {
    msg: String
  },
  created(){
    window.addEventListener("scroll", function () {
      if (document.querySelector("#background3").getBoundingClientRect().top < this.window.innerHeight){
        document.querySelector("#transbox3").classList.add("animation")
      } 
    })
  }
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
li{
  margin: 0 40px 0;
}
a {
  color: #42b983;
}

.right {
  float: right;
}

.left {
  float: left;
}

div.backgroundGestionAmbiental {
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 5px;
  padding-bottom: 5px;
  min-width: 800px;
}

div.transbox {
   margin: 30px;
  padding : 5%;
  font-family: Arial, Helvetica, sans-serif;
  text-align: justify;
  background: linear-gradient(300deg, rgb(27, 94, 32, 0.8) 0%, rgba(144,238,144,0.8) 50%, rgb(255, 255, 255, 0.8) 100%);
  box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);
  border-radius: 15px;
  min-width: 750px;
}

div {
  font-size: 30px;
}

.animation{
  animation-name: opacity1;
  animation-duration: 1000ms;
  transform-origin:70% 70%;
  animation-iteration-count: initial;
  animation-timing-function: linear;
}

@keyframes opacity1 {
  0% {
        display: none;
        opacity: 0;
    }

    1% {
        display: block;
        opacity: 0;
    }

    100% {
        display: block;
        opacity: 0.8;
    }
}
.pulse:hover {
    animation-name: pulse_animation1;
    animation-duration: 5000ms;
    transform-origin:0% 70%;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

@keyframes pulse_animation1 {
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
}
</style>